import React from "react"

import { ReactComponent as IconArrow } from "@common_assets/svg/arrowBack.svg"
import { Box, BoxProps, Fab } from "@mui/material"
import { useTranslation } from "react-i18next"

interface IProps {
  onClickLeft: () => void
  onClickRight: () => void
  onDisabledLeft: boolean
  onDisabledRight: boolean
  boxProps?: BoxProps
}

const ArrowButton = ({
  onClickLeft,
  onClickRight,
  onDisabledLeft,
  onDisabledRight,
  boxProps,
}: IProps) => {
  const { t } = useTranslation()

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      {...boxProps}
    >
      <Fab
        aria-label={t("previous")}
        disabled={onDisabledLeft}
        onClick={onClickLeft}
      >
        <IconArrow />
      </Fab>
      <Fab
        aria-label={t("next")}
        disabled={onDisabledRight}
        onClick={onClickRight}
      >
        <IconArrow style={{ transform: "rotate(180deg)" }} />
      </Fab>
    </Box>
  )
}

export default ArrowButton
